export default __webpack_public_path__ + "static/media/1874.6a41f850.png";